import React, { useState, useEffect } from 'react';
import { object, func, bool } from 'prop-types';

import { CloneObject } from '../../../utils/helpers';
import { useForm } from '@laramie/ui';
import { isValidDate, isValidNumber } from '../../../utils/validator';
import {TIPS} from "../../../consts/tips";


import { useFormErrors } from '../../hooks/useFormErrors';
import { DatePickerCustom, FormError, FormLabel, InputNumber, Modal } from '../../common';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';

const TipoElementoValorModal = (props) => {

  const entityInit = {
    id: 0,
    idTipoElemento: 0,
    valor: 0,
    fechaDesde: null,
    fechaHasta: null
  };

  const [entity, setEntity] = useState(entityInit)

  const [ formValues, formHandle, , formSet ] = useForm({
    valor: 0,
    fechaDesde: null,
    fechaHasta: null
  });

  const mount = () => {
    setEntity(props.data.entity);
    formSet({
      valor: props.data.entity.valor,
      fechaDesde: props.data.entity.fechaDesde,
      fechaHasta: props.data.entity.fechaHasta
    });
  }
  useEffect(mount, [props.data.entity]);

  const { errorOf, validate } = useFormErrors(getErrors);

  //handles
  const handleClickAceptar = () => {
    if (validate()) {

      let row = CloneObject(entity);
      row.valor = formValues.valor;
      row.fechaDesde = formValues.fechaDesde;
      row.fechaHasta = formValues.fechaHasta;

      props.onConfirm(row);
    };
  };
  //funciones
  function getErrors() {

      const errors = {};

      if (!isValidNumber(formValues.valor, false)) errors.valor = VALIDATION_MESSAGE.REQUIRED
      if (!isValidDate(formValues.fechaDesde, false)) errors.fechaDesde = VALIDATION_MESSAGE.REQUIRED_DATE
      if (!isValidDate(formValues.fechaHasta, false)) errors.fechaHasta = VALIDATION_MESSAGE.REQUIRED_DATE

      return errors;
  }

  return (
    <>

    <Modal
      size="md"
      title="Valor"
      tipName={TIPS.NAME.MODALS.VALOR_MODAL}
      onEscape={() => props.onDismiss()}
      body={(
            <div className="row">

              <div className="mb-3 col-12">
                  <FormLabel htmlFor="valor" required>Valor</FormLabel>
                  <InputNumber
                      name="valor"
                      placeholder=""
                      precision={2}
                      className={`form-control ${errorOf('valor') ? 'is-invalid' : ''}`}
                      value={ formValues.valor }
                      onChange={ formHandle }
                      disabled={props.disabled}
                  />
                  <FormError message={errorOf('valor')} />
              </div>
              <div className="mb-3 col-6">
                  <FormLabel htmlFor="fechaDesde" required>Fecha desde</FormLabel>
                  <DatePickerCustom
                      name="fechaDesde"
                      placeholder=""
                      className={`form-control ${errorOf('fechaDesde') ? 'is-invalid' : ''}`}
                      value={ formValues.fechaDesde }
                      onChange={ formHandle }
                      disabled={props.disabled}
                  />
                  <FormError message={errorOf('fechaDesde')} />
              </div>
              <div className="mb-3 col-6">
                  <FormLabel htmlFor="fechaHasta" required>Fecha hasta</FormLabel>
                  <DatePickerCustom
                      name="fechaHasta"
                      placeholder=""
                      className={`form-control ${errorOf('fechaHasta') ? 'is-invalid' : ''}`}
                      value={ formValues.fechaHasta }
                      onChange={ formHandle }
                      disabled={props.disabled}
                      minValue={formValues.fechaDesde}
                  />
                  <FormError message={errorOf('fechaHasta')} />
              </div>

            </div>
      )}
      footer={!props.disabled ? (<>
            <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Cancelar</button>
            <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
      </>) : (
            <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
      )}
      footerClassName={props.disabled ? 'f-align' : ''}
    />

    </>
  );
}

TipoElementoValorModal.propTypes = {
  disabled: bool,
  data: object.isRequired,
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
};

TipoElementoValorModal.defaultProps = {
  disabled: false
};

export default TipoElementoValorModal;